@if (showSpinner()) {
    <woa-spinner class="initiation-spinner"></woa-spinner>
}
@if (payFormError()) {
    <woa-content-message [level]="MessageLevel.ERROR" [text]="'woa.error.payment.paymentMethodUnavailable'"
                         [translationParams]="{cause: payFormError()}"></woa-content-message>
}
<div #cardHolder class="card-holder" [class.hidden]="showSpinner()"></div>
@if (showSavePaymentDetailsOption()) {
    <woa-selector-control class="save-card" [class.hidden]="showSpinner()"
                         [label]="'woa.label.payment.saveCardDetails'"
                         [(selected)]="savePaymentDetails"></woa-selector-control>
}
